import { render, staticRenderFns } from "./BlankCard.vue?vue&type=template&id=3261d9bd&"
import script from "./BlankCard.vue?vue&type=script&lang=js&"
export * from "./BlankCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports